import React from "react";
import { brandColors } from "../../../lib/color";

interface Props {
  color?: string;
  direction?: "up" | "right" | "down" | "left";
  className?: string;
  id?: string;
}

const Arrow: React.FC<Props> = ({
  color = brandColors.navy,
  direction = "down",
  id = "b",
  ...props
}) => {
  let arrowStyles = {
    up: { transform: "rotate(180deg)" },
    right: { transform: "rotate(-90deg)" },
    down: {},
    left: { transform: "rotate(90deg)" },
  };

  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 7.904 5.016"
      xmlns="http://www.w3.org/2000/svg"
      style={arrowStyles[direction]}
      id={id}
      data-name={id}
      {...props}
    >
      <path
        id={`path-${id}`}
        fill="none"
        stroke={color}
        strokeWidth={1.05833}
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit={4}
        strokeDasharray="none"
        strokeOpacity={1}
        d="M.387.361 4 4.234 7.51.361"
      />
    </svg>
  );
};

export default Arrow;
